export default {
  nav: {
    home: "Strona główna",
    engines: "Silniki",
    transmissions: "Skrzynie biegów",
    bodyParts: "Części karoserii",
    testimonials: "Opinie",
    contact: "Kontakt",
    getQuote: "Poproś o wycenę",
    menu: "Otwórz menu",
  },
  banner: {
    text: "WIELKA WYPRZEDAŻ — Do 30% ZNIŻKI na wybrane silniki, skrzynie biegów i części karoserii. Wysyłka dostępna w całej Australii.",
  },
  hero: {
    badge: "Zaufanie od 2005",
    title1: "Jakościowe używane silniki i",
    titleHighlight: "Skrzynie biegów",
    desc: "{{siteName}} to Twój kompleksowy sklep z używanymi, nowymi i zamiennymi częściami, z wysyłką w całej Australii. Specjaliści od najpopularniejszych australijskich pick-upów i SUV-ów.",
    contact: "Kontakt",
    browse: "Przeglądaj silniki",
  },
  about: {
    f1title: "Firma rodzinna",
    f1text: "{{siteName}} to rodzinny biznes z Darwin zbudowany na zaufaniu, ciężkiej pracy i prawdziwej trosce o każdego klienta.",
    f2title: "Reputacja",
    f2text: "Cieszymy się silną reputacją zbudowaną na uczciwości, sprawiedliwości i wiedzy technicznej w zakresie części używanych, nowych i zamiennych.",
    f3title: "Co robimy",
    f3text: "Jesteśmy Twoim kompleksowym sklepem z używanymi, nowymi i zamiennymi częściami, wspieranym przez wyspecjalizowany warsztat serwisowo-naprawczy.",
    f4title: "Wysoko wykwalifikowani",
    f4text: "Nasi doświadczeni technicy używają najnowszych programów diagnostycznych i skanerów, aby pomóc Ci uniknąć niepotrzebnych kosztów naprawy.",
    stockLabel: "Co mamy na stanie",
    modelsTitle: "Popularne modele, które obsługujemy",
    modelsDesc: "Koncentrujemy się na najlepiej sprzedających się australijskich pick-upach i SUV-ach, abyś szybko otrzymał właściwą część.",
  },
  why: {
    promise: "Nasza obietnica",
    title: "Dlaczego my",
    w1title: "Jakość",
    w1text: "Spokój ducha, że za każdym razem otrzymujesz wysokiej jakości część i usługę.",
    w2title: "Oszczędności",
    w2text: "Zatrzymaj więcej pieniędzy w kieszeni dzięki naszym doskonałym rabatom na wszystkie części, nowe i używane.",
    w3title: "Gwarancja",
    w3text: "Nowe części mają 12 miesięcy gwarancji, a używane 3 miesiące gwarancji.",
    w4title: "Wysyłka",
    w4text: "Małe przedmioty wysyłamy w 24h, a większe w ciągu 1 do 3 dni w całej Australii.",
    missionTitle: "Nasza misja",
    missionText: "Zapewnić Tobie, naszym klientom i społeczności, światowej klasy obsługę klienta. Dążymy do najwyższej jakości we wszystkim, co robimy, aby jak najlepiej Ci służyć — poprzez nasze cztery filary wartości: Rodzina, Zaangażowanie, Innowacja i Jakość.",
    valuesTitle: "Nasze wartości",
    v1label: "Rodzina",
    v1text: "Jesteśmy jednym zespołem, który troszczy się o klientów, pracowników i dostawców.",
    v2label: "Zaangażowanie",
    v2text: "Dążymy do najlepszego w tym, co robimy, z prawdziwą pasją do sukcesu.",
    v3label: "Innowacja",
    v3text: "Myślimy nieszablonowo i ciężko pracujemy, aby stale się doskonalić.",
    v4label: "Jakość",
    v4text: "Staramy się zrobić to dobrze za pierwszym razem, za każdym razem.",
    t1text: "Świetna obsługa. Naprawili usterkę tego samego dnia i cały czas się ze mną komunikowali — a wszystko w doskonałej cenie!",
    t1name: "Nico A.",
    t1loc: "Darwin",
    t2text: "Znalazłem dokładnie ten silnik, którego potrzebowałem do mojego HiLuxa. Przyjaźni, uczciwi i naprawdę znający się na australijskich pick-upach. Gorąco polecam.",
    t2name: "Chris N.",
    t2loc: "Palmerston",
    t3text: "Bardzo pomocni, uczciwi i rzetelni, z jakościowymi używanymi częściami do wszystkich popularnych modeli. Wielkie brawa!",
    t3name: "Stephen C.",
    t3loc: "Darwin",
    t4text: "Przyjechałem z nieznanymi problemami, a ci goście szybko postawili mnie na nogi. Fantastyczna obsługa.",
    t4name: "Armand D.",
    t4loc: "Katherine",
  },
  brand: {
    strip: "Części do wszystkich głównych marek",
  },
  cta: {
    title: "Szukasz części?",
    desc: "Powiedz nam, czego potrzebujesz, a nasz zespół zdobędzie to dla Ciebie. Wysyłamy w całej Australii z naszego warsztatu w Winnellie, Darwin.",
    request: "Poproś o wycenę",
  },
  footer: {
    brandDesc: "Zaufane źródło Australii dla jakościowych używanych silników, skrzyń biegów i części karoserii. Firma rodzinna skoncentrowana na najpopularniejszych australijskich pick-upach i SUV-ach.",
    quickLinks: "Szybkie linki",
    company: "Firma",
    getInTouch: "Skontaktuj się",
    monFri: "Pon - Pt: 8:00 - 17:00",
    copyright: "© Prawa autorskie {{year}} {{siteName}}. Wszelkie prawa zastrzeżone.",
    disclaimer: "{{siteName}} jest niezależnym specjalistą od części i usług.",
  },
  page: {
    enginesSubtitle: "Jakościowe używane, nowe i regenerowane silniki do wszystkich marek i modeli – europejskich, japońskich i amerykańskich. Każdy silnik jest sprawdzany, plombowany i objęty gwarancją.",
    transmissionsSubtitle: "Używane i nowe automatyczne oraz manualne skrzynie biegów do wszystkich marek i modeli – europejskich, japońskich i amerykańskich. Każda skrzynia jest sprawdzana, testowana i objęta gwarancją.",
    bodyPartsSubtitle: "Używane i zamienne panele karoserii, zderzaki, lusterka, światła i listwy do wszystkich marek i modeli. Proste blachy, konkurencyjne ceny z gwarancją.",
  },
  grid: {
    ourStock: "Nasz asortyment",
    itemsInStock: "{{count}} pozycji na stanie",
    shipping: "Wysyłka w całej Australii",
    price: "Cena",
    enquire: "Zapytaj teraz",
    searchPlaceholder: "Szukaj po marce, modelu lub nazwie części...",
    allMakes: "Wszystkie marki",
    allModels: "Wszystkie modele",
    noResults: "Żadna część nie pasuje do wyszukiwania. Spróbuj innej marki lub modelu.",
    clearFilters: "Wyczyść filtry",
  },
  availability: {
    badge: "Aktualizacja stanu",
    title: "Używane i nowe {{category}}",
    text: "Mamy silniki, skrzynie biegów i części karoserii do wszystkich marek i modeli. Oferujemy szeroką gamę silników, skrzyń biegów i części karoserii do samochodów europejskich, japońskich, kanadyjskich i amerykańskich. Wszystkie części są sprawdzane i spełniają wymagania jakościowe, którym podlegają; każdy element jest plombowany i nosi specjalne oznaczenie. Wszystkie używane części objęte są długoterminową gwarancją jakości. Jeśli masz wątpliwości co do wyboru silnika, skrzyni biegów lub części karoserii, skontaktuj się z naszym zespołem – chętnie odpowiemy na Twoje pytania i udzielimy kompleksowej porady. {{siteName}} – wygodne wyszukiwanie używanych i nowych części, z szybką dostawą towaru w ciągu 1–3 dni roboczych od otrzymania płatności.",
    cta: "Kontakt",
  },
  request: {
    badge: "Brakuje części?",
    title: "Nie możesz znaleźć potrzebnej części?",
    text: "{{siteName}} co tydzień zdobywa trudno dostępne silniki, skrzynie biegów i części karoserii. Podaj nam markę, model i rocznik — jeśli dziś nie ma jej na stanie, nasz zespół ją znajdzie i szybko się odezwie.",
    cta: "Zamów część",
  },
  partsWeSource: {
    badge: "Zamówienie specjalne",
    title: "Części, które zdobywamy",
    desc: "Nie widzisz tego, czego szukasz? {{siteName}} co tydzień znajduje trudno dostępne części — od rzadkich sterowników i komputerów po te wyjątkowe elementy, których nikt inny nie ma na stanie.",
    ecuTitle: "Sterowniki i jednostki sterujące",
    ecuText: "Moduły sterujące silnika, skrzyni i karoserii, programowane i testowane pod Twój pojazd.",
    computerBoxTitle: "Komputery (boxy)",
    computerBoxText: "Komputery zarządzania silnikiem i moduły z wiązkami do pick-upów, SUV-ów i nie tylko.",
    hardToFindTitle: "Trudno dostępne części",
    hardToFindText: "Rzadkie listwy, wycofane panele i specjalistyczne części pozyskiwane przez naszą ogólnokrajową sieć.",
    cta: "Zamów część",
  },
  contact: {
    badge: "Nawiąż kontakt",
    title: "Kontakt",
    desc: "Masz na myśli jakąś część? Wyślij nam zapytanie, a nasz zespół szybko odpowie. Wysyłamy w całej Australii z Winnellie, Darwin NT 0820.",
    sendEnquiry: "Wyślij zapytanie",
    formDesc: "Wypełnij formularz, a wkrótce się z Tobą skontaktujemy.",
    prefill: "Wstępnie wypełniliśmy część, o którą pytasz. Dodaj tylko swoje dane i ewentualne uwagi poniżej.",
    name: "Imię i nazwisko",
    namePlaceholder: "Twoje pełne imię i nazwisko",
    email: "E-mail",
    emailPlaceholder: "ty@email.pl",
    phone: "Telefon",
    phonePlaceholder: "+61 4xx xxx xxx",
    subject: "Temat",
    subjectPlaceholder: "Wybierz temat",
    subjectEngine: "Zapytanie o silnik",
    subjectTransmission: "Zapytanie o skrzynię biegów",
    subjectBody: "Zapytanie o część karoserii",
    subjectGeneral: "Zapytanie ogólne",
    subjectSpecialOrder: "Zamówienie specjalne / Prośba o część",
    part: "Część / przedmiot zapytania",
    partPlaceholder: "np. Silnik – Toyota HiLux 2018",
    vehicle: "Pojazd (Marka, Model i Rocznik)",
    vehiclePlaceholder: "np. Toyota HiLux 2018",
    notes: "Uwagi",
    notesPlaceholder: "Powiedz nam, jakiej części szukasz...",
    maxChars: "Maks. 500 znaków",
    partPhoto: "Zdjęcie części (opcjonalnie)",
    partPhotoHint: "JPG, PNG lub WebP, do 8 MB. Pomaga nam szybciej zidentyfikować dokładną część.",
    choosePhoto: "Wybierz zdjęcie",
    removePhoto: "Usuń zdjęcie",
    photoInvalid: "Wybierz plik obrazu (JPG, PNG lub WebP).",
    photoTooLarge: "Ten obraz jest za duży. Wybierz plik poniżej 8 MB.",
    success: "Dziękujemy za zapytanie! Odezwiemy się wkrótce.",
    sending: "Wysyłanie...",
    send: "Wyślij zapytanie",
    details: "Nasze dane",
    addressLabel: "Adres",
    phoneLabel: "Telefon",
    emailLabel: "E-mail",
    hoursLabel: "Godziny otwarcia",
    sat: "Sob: Po umówieniu",
  },
  detail: {
    home: "Strona główna",
    photos: "Zdjęcia",
    specifications: "Specyfikacja",
    make: "Marka",
    model: "Model",
    year: "Rocznik",
    fitment: "Dopasowanie",
    condition: "Stan",
    warranty: "Gwarancja",
    notFound: "Nie znaleziono tej części. Mogła zostać sprzedana lub usunięta.",
    backHome: "Wróć na stronę główną",
    backToList: "Wróć do listy",
  },
};